<template>
<div id="demo" class="carousel slide vert" data-ride="carousel">

    <div class="row  mx-auto">

        <div class="col-md-4 col-12 order-md-1 order-2 text-center">
            <div class="carousel-indicators" style="overflow:visible">
                <div v-for="(image,idx) in images" :key="idx"  data-target="#demo" :data-slide-to="idx" :class=" (idx == 0)? 'item active' : 'item'">
                    <el-image style="width: 100%; height: 100%" :src="baseURL + image" fit="cover" >
                    </el-image>
                 </div>
                <!-- <div data-target="#demo" data-slide-to="0" class="item active"><img src="@/assets/examples/thumb1.jpg" alt=""></div>
                <div data-target="#demo" data-slide-to="1" class="item"><img src="@/assets/examples/thumb2.jpg" alt=""></div>
                <div data-target="#demo" data-slide-to="2" class="item"><img src="@/assets/examples/thumb3.jpg" alt=""></div> -->
            </div>
        </div><!-- col-sm-4 Indicators -->

        <div class="col-md-8 col-12 order-md-2 order-1 text-center">
            <div class="carousel-inner">
                <div  v-for="(image , idx) in images" :key="idx" :class="(idx == 0)? 'carousel-item  active' : 'carousel-item '">
                    <el-image style="width: 100%; height: 100%" :src="baseURL + image" fit="contain" :preview-src-list="srcList">
                    </el-image>
                </div>
                <!-- <div class="carousel-item">
                    <el-image style="width: 100%; height: 100%" :src="require('@/assets/examples/w5.jpg')" fit="contain" :preview-src-list="srcList">
                    </el-image>
                </div>
                <div class="carousel-item">
                    <el-image style="width: 100%; height: 100%" :src="require('@/assets/examples/w5.jpg')" fit="contain" :preview-src-list="srcList">
                    </el-image>
                </div>
                <div class="carousel-item">
                    <el-image style="width: 100%; height: 100%" :src="require('@/assets/examples/w5.jpg')" fit="contain" :preview-src-list="srcList">
                    </el-image>
                </div> -->

            </div>
            <!--inner-->
            <a class="carousel-control-prev" href="#demo" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#demo" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div><!-- col-sm-6  -->

    </div>
    <!--row-->

</div>
</template>

<script>
export default {
    name: 'Carousel',
    props:{
        images: Array
    },
    computed:{
        baseURL: {
        get() {return localStorage.getItem('country') == 'TZ' ? 'https://tz.time-zone.store' : 'https://time-zone.store/'}
      }
    },
    data() {
        return {
            srcList: [],
            srcListStatic: [require('@/assets/examples/w5.jpg'), require('@/assets/examples/w5.jpg'),require('@/assets/examples/w5.jpg'),require('@/assets/examples/w5.jpg')]
        }
    }, 
    watch:{
        images(val){
            val.forEach(element => {
                this.srcList.push(this.baseURL + element)
            });
        }
    },
    methods: {},
    props: ['startingImage', 'images', 'autoSlideInterval', 'showProgressBar']
}
</script>

<style scoped>
.carousel-control-next-icon,
.carousel-control-prev-icon {
    filter: invert(1);
}

.carousel {
    padding-top: 16px
}

/* Make the image fully responsive */
.carousel-item,
.carousel-inner {
    height: 100%;
}

.carousel-inner img {
    width: 100%;
    height: 100%;
}

.carousel-indicators {
    display: inline-block;
    height: 300px;
    overflow-y: scroll;
    overflow-x: hidden;
    position: static;
    direction: rtl;
}

@media screen and (max-width:992px) {
    .carousel-indicators {
        display: inline-flex;
        direction: inherit;
        height: auto;
        width: 100%;
        max-width: 800px;
        overflow-x: auto;
        position: relative;
        margin-left: 0;
        margin-right: 0;
        overflow-y: hidden;
        justify-content: normal;
        margin-bottom: 20px;
    }

    .carousel-inner {
        margin-left: 0 !important;
    }
}

/* width */
::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.item {
    margin-bottom: 10px;
    margin-left: 10px;
    cursor: pointer;
    height: 90px;
    width: 90px
}

.item.active  {
    border: 1px solid #2e368f;
    opacity: 1;
}

.item img {
    border: 1px solid transparent;
    opacity: 0.5;
    transition: 0.5s;
    width: 100%;
    height: 100%;
}

.item:hover img {
    border: 1px solid #2e368f;
    opacity: 1;
}

.content {
    position: absolute;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    /* Black background with transparency */
    color: #f1f1f1;
    width: 100%;
    padding: 10px;
}

.content p {
    font-size: 15px;
}

@media screen and (max-width: 992px) {
    .content {
        position: static;
    }
}

@media screen and (min-width: 1440px) {
    .carousel-inner {
        margin-left: -60px;
    }
}

@media screen and (min-width: 1200px) and (max-width: 1439px) {
    .carousel-inner {
        margin-left: -20px;
    }
}

@media screen and (min-width: 880px) and (max-width: 1199px) {
    .carousel-inner {
        margin-left: 20px;
    }

    .content {
        position: static;
    }
}

@media screen and (min-width: 576px) and (max-width: 879px) {
    .carousel-inner {
        margin-left: 50px;
    }

    .content {
        position: static;
    }
}

.vert .carousel-item-next.carousel-item-left,
.vert .carousel-item-prev.carousel-item-right {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
}

.vert .carousel-item-next,
.vert .active.carousel-item-right {
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100% 0);
}

.vert .carousel-item-prev,
.vert .active.carousel-item-left {
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
}
 
/*
.carousel-item {

    background-image: url('~@/assets/examples/w5.jpg');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
}*/
</style>
